import React from "react";
import Styles from "./styles.module.scss";

import bnbIcon from "../../../theme/assets/crypto/bnb.svg";
import btcIcon from "../../../theme/assets/crypto/btc.svg";
import ethIcon from "../../../theme/assets/crypto/eth.svg";
import solIcon from "../../../theme/assets/crypto/sol.svg";
import trxIcon from "../../../theme/assets/crypto/trx.svg";
import usdtIcon from "../../../theme/assets/crypto/usdt.svg";
import usdcIcon from "../../../theme/assets/crypto/usdc.svg";

import usdcBep20Icon from "../../../theme/assets/crypto/usdc_bep_20.svg";
import usdcErc20Icon from "../../../theme/assets/crypto/usdc_erc_20.svg";
import usdtBep20Icon from "../../../theme/assets/crypto/usdt_bep_20.svg";
import usdtErc20Icon from "../../../theme/assets/crypto/usdt_erc_20.svg";
import usdtTrc20Icon from "../../../theme/assets/crypto/usdt_trc_20.svg";

const cryptoIcons = {
    BTC: btcIcon,
    ETH: ethIcon,
    BNB: bnbIcon,
    SOL: solIcon,
    TRX: trxIcon,
    USDT: usdtIcon,
    USDC: usdcIcon,
};

const cryptoNetworkIcons = {
    USDT_TRC20: usdtTrc20Icon,
    USDT_TRC_20: usdtTrc20Icon,
    USDT_TRX: usdtTrc20Icon,
    USDT_TRON: usdtTrc20Icon,

    USDT_ERC20: usdtErc20Icon,
    USDT_ERC_20: usdtErc20Icon,
    USDT_ETH: usdtErc20Icon,
    USDT_ETHEREUM: usdtErc20Icon,

    USDT_BEP20: usdtBep20Icon,
    USDT_BEP_20: usdtBep20Icon,
    USDT_BNB: usdtBep20Icon,
    USDT_BSC: usdtBep20Icon,
    USDT_BINANCE_SMART_CHAIN: usdtBep20Icon,

    USDC_ERC20: usdcErc20Icon,
    USDC_ERC_20: usdcErc20Icon,
    USDC_ETH: usdcErc20Icon,
    USDC_ETHEREUM: usdcErc20Icon,

    USDC_BEP20: usdcBep20Icon,
    USDC_BEP_20: usdcBep20Icon,
    USDC_BNB: usdcBep20Icon,
    USDC_BSC: usdcBep20Icon,
    USDC_BINANCE_SMART_CHAIN: usdcBep20Icon,
};

const normalizeIconPart = (value) => {
    return String(value || "")
        .toUpperCase()
        .replace(/[\s-]+/g, "_");
};

export const getCryptoIcon = (code, networkCode, assetType) => {
    if (!code) return null;

    const normalizedCode = normalizeIconPart(code);
    const normalizedNetworkCode = normalizeIconPart(networkCode);
    const normalizedAssetType = normalizeIconPart(assetType);

    const assetTypeIconKey = normalizedAssetType
        ? `${normalizedCode}_${normalizedAssetType}`
        : "";

    const networkIconKey = normalizedNetworkCode
        ? `${normalizedCode}_${normalizedNetworkCode}`
        : "";

    return (
        cryptoNetworkIcons[assetTypeIconKey] ||
        cryptoNetworkIcons[networkIconKey] ||
        cryptoIcons[normalizedCode] ||
        null
    );
};

export const getCryptoShortLabel = (code) => {
    switch (String(code).toUpperCase()) {
        case "ETH":
            return "Ξ";
        case "BNB":
            return "B";
        case "USDT":
            return "T";
        case "USDC":
            return "U";
        case "TRX":
            return "T";
        case "BTC":
            return "B";
        case "SOL":
            return "S";
        default:
            return code?.slice(0, 1) || "?";
    }
};

const CryptoIcon = ({
                        code,
                        networkCode,
                        assetType,
                        alt,
                        className = "",
                    }) => {
    const normalizedCode = String(code || "").toUpperCase();
    const icon = getCryptoIcon(normalizedCode, networkCode, assetType);

    return (
        <div className={`${Styles.cryptoIcon} ${className}`}>
            {icon ? (
                <img src={icon} alt={alt || normalizedCode} />
            ) : (
                <span>{getCryptoShortLabel(normalizedCode)}</span>
            )}
        </div>
    );
};

export default CryptoIcon;
